import { z } from 'zod';
import { CAL_EVENT_CONTACT_KINDS } from '../../events/cal-event-contact-kind.js';
import { optionalTrimmedNullableEmail, optionalTrimmedNullableString, } from '../zod-helpers/index.js';
import { CAL_EVENT_CONTACT_CONSTRAINTS as LIMITS } from './constraints.js';
const tooLong = (field) => `${LIMITS[field].label} must be ${LIMITS[field].maxLength} characters or fewer.`;
export const contactFieldsInputSchema = z.object({
    name: optionalTrimmedNullableString(LIMITS.name.maxLength, tooLong('name')),
    phone: optionalTrimmedNullableString(LIMITS.phone.maxLength, tooLong('phone')),
    email: optionalTrimmedNullableEmail(LIMITS.email.maxLength, 'Enter a valid email address.'),
    kind: z.enum(CAL_EVENT_CONTACT_KINDS, 'Invalid contact kind.').nullish(),
    company: optionalTrimmedNullableString(LIMITS.company.maxLength, tooLong('company')),
    role: optionalTrimmedNullableString(LIMITS.role.maxLength, tooLong('role')),
});
//# sourceMappingURL=contact-fields-input.js.map